import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const wrap: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
};

const headWrap: CSSObject = {
  position: 'sticky',
  top: '-1px',
  paddingTop: '12px',
  background: color.background,
  zIndex: 2,
  '> div': {
    background: color.white,
    padding: '24px 24px 12px 24px',
    borderRadius: `${radius.xl}px ${radius.xl}px 0 0`,
  },
  [mobile]: {
    '> div': {
      padding: '20px 16px 12px',
      borderRadius: `${radius.lg}px ${radius.lg}px 0 0`,
    },
  },
};

const contentsWrap = (top: number): CSSObject => ({
  padding: '0 24px',
  background: color.white,
  overflowX: 'auto',
  '> table > thead': {
    position: 'sticky',
    top: `${top - 1}px`,
  },
  [mobile]: {
    padding: '0 16px',
  },
});

const footWrap: CSSObject = {
  position: 'sticky',
  bottom: '0px',
  '> div': {
    padding: '0 24px 24px 24px',
    background: color.white,
    borderRadius: `0 0 ${radius.xl}px ${radius.xl}px`,
  },
  [mobile]: {
    '> div': {
      padding: '0 16px 16px',
      borderRadius: `0 0 ${radius.lg}px ${radius.lg}px`,
    },
  },
};

export { wrap, headWrap, contentsWrap, footWrap };
